/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class QueryOperatorUnaryNotForGraph extends models.QueryOperatorUnaryForGraph {
    constructor() {
        super();
        this.setDiscriminator("QueryOperatorUnaryNotForGraph");
    }

    getFixupPrototypeFunction() { return QueryOperatorUnaryNotForGraph.fixupPrototype; }

    static newInstance(model: Partial<QueryOperatorUnaryNotForGraph>): QueryOperatorUnaryNotForGraph {
        let obj = Object.assign(new QueryOperatorUnaryNotForGraph(), model);
        QueryOperatorUnaryNotForGraph.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<QueryOperatorUnaryNotForGraph>): QueryOperatorUnaryNotForGraph {
        if (!model) return null;
        return QueryOperatorUnaryNotForGraph.newInstance(<QueryOperatorUnaryNotForGraph> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: QueryOperatorUnaryNotForGraph) {
        if (!obj) return;

        models.QueryOperatorUnaryNotForGraph.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: QueryOperatorUnaryNotForGraph): boolean {
        if (models.QueryOperatorUnaryForGraph.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, QueryOperatorUnaryNotForGraph.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
